import api from '@/api'

const { $whatsapp} = api;

export const { $areas,$templates, $messagePhone} = $whatsapp;